import React from "react";
import { SidebarPage } from "../supervisorsidebar";
import { NavbarPage } from "../supervisornavbar";
import { HeaderPage } from "../supervisorheader";

function SupervisorLayout({ children }) {
  return (
    <>
      <div>
        <main>
          <SidebarPage />
          <NavbarPage />
          <HeaderPage />
          {children}
        </main>
      </div>
    </>
  );
}

export default SupervisorLayout;
